import { useList } from "@refinedev/core";
import { CollapsibleSection } from "components/collapsibleSection";
import { IOrderDetail, IProductItem } from "interfaces";
import { useEffect, useState } from "react";
import { DEFAULT_PAGE_SIZE } from "utills/constants";
import { ProductTable } from "./table";
import { ProductCard } from "./card";
import Pagination from "components/pagination";
import { isEmpty } from "lodash";

export const EditPurchasedProductSection = ({orderDetailData, rate} : {orderDetailData: IOrderDetail | null, rate: number}) => {
  const [filters, setFilters] = useState({
    page: "1",
  });

  const [trigger, setTrigger] = useState(false);

  const {
    data: productData,
    refetch,
    isFetching,
  } = useList<IProductItem>({
    resource: `checkout/orders/${orderDetailData?.code}/items`,
    pagination: {
      mode: "off",
      pageSize: DEFAULT_PAGE_SIZE,
    },
    meta: {
      resource: "items",
      filters: [{ field: "page", operator: "eq", value: filters.page }],
    },
    queryOptions: {
      enabled: false,
    } as any,
  });

    useEffect(() => {
      if (trigger) {
        refetch();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger, filters]);
  
  const _handleFilterChange = (key: string, value: any) => {
    const updatedFilter = {
      [key]: value,
      ...(key !== "page" && { page: "1" }),
    };
    setFilters({
      ...filters,
      ...updatedFilter,
    });
  };

  return (
    <CollapsibleSection 
      label="Purchased product"
      defaultOpen={false}
      onClick={() => setTrigger(true)}
    >
      <div className="px-4 py-4 sm:px-6">
        {isEmpty(productData?.data) && !isFetching && (
          <div className="text-center">
            No data
          </div>
        )}
        {!isEmpty(productData?.data) ? (
          <>
            <div className="hidden sm:block">
              <ProductTable 
                currentPage={productData?.paging.currentPage}
                pageSize={productData?.pageSize}
                data={productData?.data}
                orderCurrency={orderDetailData?.currency ?? ""}
                rate={rate}
              />
            </div>
            <div className="sm:hidden">
              <ProductCard 
                currentPage={productData?.paging.currentPage}
                pageSize={productData?.pageSize} 
                data={productData?.data}
                orderCurrency={orderDetailData?.currency ?? ""}
                rate={rate}
              />
            </div>
          </>
        ) : <></>}
        {productData?.paging && productData.paging.total_page > 1 ? (
          <div className="mt-4 px-4 py-4 sm:px-6 flex justify-end items-center">
            <Pagination
              hideTotal
              currentPage={productData?.paging.current_page}
              totalPage={productData?.paging.total_page}
              total={{
                totalItems: productData?.paging.total_item || 0,
                total: productData?.paging.total,
              }}
              onChange={(page: number) =>
                _handleFilterChange("page", page)
              }
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </CollapsibleSection>
  )
}